"use client";

import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription } from "#/components/ui/drawer";
import { Badge } from "#/components/ui/badge";
import { Briefcase } from "lucide-react";
import { experiences } from "#/data";

interface AchievementsDrawerProps {
  experience: (typeof experiences)[0] | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AchievementsDrawer({ experience, open, onOpenChange }: AchievementsDrawerProps) {
  if (!experience) return null;

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="max-h-[90vh] bg-white dark:bg-neutral-900">
        <div className="mx-auto w-full max-w-3xl">
          <DrawerHeader className="px-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Briefcase className="h-5 w-5 text-neutral-700 dark:text-neutral-300" />
                <DrawerTitle className="text-xl font-semibold">{experience.title}</DrawerTitle>
              </div>
            </div>
            <DrawerDescription className="mt-2 text-neutral-700 dark:text-neutral-300">
              {experience.company} - {experience.type}
            </DrawerDescription>

            {experience.skills && experience.skills.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-3">
                {experience.skills.map((skill, index) => (
                  <Badge key={index} variant="outline" className="bg-neutral-100 dark:bg-neutral-800">
                    {skill}
                  </Badge>
                ))}
              </div>
            )}
          </DrawerHeader>

          <div className="px-6 py-4 overflow-y-auto max-h-[60vh]">
            <h3 className="text-lg font-medium mb-4 text-neutral-900 dark:text-neutral-100">Réalisations</h3>
            {experience.achievements && experience.achievements.length > 0 ? (
              <ul className="list-disc pl-5 space-y-3">
                {experience.achievements.map((achievement, index) => (
                  <li key={index} className="flex items-center gap-2 text-neutral-700 dark:text-neutral-300">
                    <span className="h-1.5 w-1.5 min-h-1.5 min-w-1.5 rounded-full bg-teal-500"></span>
                    {achievement}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-neutral-500 dark:text-neutral-400">Aucune réalisation enregistrée.</p>
            )}

            {experience.impact && (
              <div
                className="mt-6 p-4 bg-neutral-50 dark:bg-neutral-800 rounded-md border
               border-neutral-200 dark:border-neutral-700"
              >
                <h4 className="text-base font-medium mb-2 text-neutral-900 dark:text-neutral-100">Impact</h4>
                <p className="text-neutral-700 dark:text-neutral-300">{experience.impact}</p>
              </div>
            )}
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
